import React, { Fragment, useContext } from 'react';
import Chip from '@material-ui/core/Chip';
import { Tr } from '@lsoft/translate';
import {
	trComingSoon,
	trDiscount,
	trNew,
	trPreOrder,
	trRare,
} from './Product.tr';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ShopProductContext } from '../../container/shop/ShopProduct';

const useStyles = makeStyles((theme) => ({
	shopGridProductLabel: {
		borderRadius: theme.spacing(1),
		'&:not(:last-child)': {
			marginRight: theme.spacing(0.5),
		},
	},
}));

export const ProductLabels = ({ hide_presale_labels, size }) => {
	const classes = useStyles();

	// noinspection JSCheckFunctionSignatures
	const {
		data: { sellable, presale, discount, discount_available, gt_new, rare },
	} = useContext(ShopProductContext);

	return (
		<Fragment>
			{!hide_presale_labels && (
				<Fragment>
					{!sellable && !presale && (
						<Chip
							color={'default'}
							size={size}
							label={<Tr tr={trComingSoon} />}
							className={clsx(classes.shopGridProductLabel)}
						/>
					)}
					{presale && (
						<Chip
							color={'secondary'}
							size={size}
							label={<Tr tr={trPreOrder} />}
							className={clsx(classes.shopGridProductLabel)}
						/>
					)}
				</Fragment>
			)}
			{gt_new && !presale && (
				<Chip
					color={'secondary'}
					size={size}
					label={<Tr tr={trNew} />}
					className={clsx(classes.shopGridProductLabel)}
				/>
			)}
			{rare && !presale && (
				<Chip
					color={'secondary'}
					size={size}
					label={<Tr tr={trRare} />}
					className={clsx(classes.shopGridProductLabel)}
				/>
			)}
			{discount_available && (
				<Chip
					color={'primary'}
					size={size}
					label={<Tr tr={trDiscount} format={{ rate: discount }} />}
					className={clsx(classes.shopGridProductLabel)}
				/>
			)}
		</Fragment>
	);
};
ProductLabels.propTypes = {
	hide_presale_labels: PropTypes.bool,
	size: PropTypes.oneOf(['small', 'medium']),
};
ProductLabels.defaultProps = {
	hide_presale_labels: false,
	size: 'small',
};
